import Loader from "react-loader-spinner";
import { faWarehouse } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { exportToExcel } from "../../store/api/CommonFunctions";
import BihamtaTable from "../../Components/BihamtaTable";
import { FileEarmarkExcelFill, List, PrinterFill, Search } from "react-bootstrap-icons";
import { getStorageStatusReport, getStorageValueReport } from "../store/api/ReportsAPI";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from "react-redux";


const StorageValueReport = () => {
    const storageName = useRef("");
    const dispatch = useDispatch();
    const history = useHistory();
    const [pending, setPending] = useState(false);
    const tableCols = [
        { colName: "RowNumber", colTitle: "ردیف" },
        { colName: "StorageName", colTitle: "نام انبار", justInMobile: true },
        { colName: "KalaCount", colTitle: "تعداد کل کالاها", justInMobile: true, styleCondition:()=>{return {direction:"ltr"}} },
        { colName: "StorageValue", colTitle: "ارزش انبار", justInMobile: true, colType:"currency" },
        { colName: "TotalPurchasePrice", colTitle: "قیمت خرید", colType:"currency" },
        { colName: "TotalSalePrice", colTitle: "قیمت فروش", colType:"currency" },
        { colName: "TotalGauranteeSalePrice", colTitle: "قیمت گارانتی", colType:"currency" }
    ]
    const rowButtons =[
        {
            type:"common", onclick:gotoStgStatus, icon:<List size={20} color="#0047ff" className="rowBtn"/>, className:"group-Btn-smalll", tooltip:"وضعیت انبار", title:"وضعیت انبار"
        }
    ]
    function toExcel() {
        const url = "api/StorageAPI/GetStorageValueReport";
        const searchArgs = { storageName: storageName.current };
        setPending(true);
        exportToExcel("StorageValueReport", searchArgs, url, "get", tableCols, () => setPending(false));
    }
    function printReport(e) {
        const searchArgs = { storageName: storageName.current };
        history.push({
            pathname: `/PrintViewer/StorageValueReport/${e.ctrlKey}`,
            state: {
                dataUrl: `api/StorageAPI/GetStorageValueReport?storageName=${storageName.current}`,
                method: "get",
                fetchBody: JSON.stringify(searchArgs)
            }
        });
    }
    function search(e){
        if(e?.key && e.key !=="Enter")
        {
            return;
        }
        dispatch( getStorageValueReport(storageName.current));
    }
    function gotoStgStatus(row)
    {
       const data={
        Skip:0,
        Take:10,
        StorageName: row.StorageName
       }
        data.Skip = 0;
        dispatch(getStorageStatusReport(data));
        history.push("/Sale/StorageStatusReport");
    }

    useEffect(() => {
        document.body.classList = "notMain";
    }, []);
    return (
        <div className="container-fluid mt-4">
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faWarehouse} size="lg" />&nbsp;
                    گزارش ارزش انبار
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <Row>
                        <Col md={3} className="form-group">
                            <Form.Control placeholder="نام انبار" onChange={e=> storageName.current = e.target.value} onKeyDown={search}/>
                            <Button className="btn-input-tiny" onClick={search} style={{top:7}}><Search size={23}/></Button>
                        </Col>
                    </Row>
                {!pending &&
                        <div style={{ padding: 0, width: "100%", textAlign: "left", marginTop: "5px" }}>
                            <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
                            <PrinterFill color="blue" size={25} style={{ cursor: "pointer" }} className="hoverIcon" onClick={printReport} />
                        </div>}
                    {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
                    <BihamtaTable columns={tableCols} rowButtons={rowButtons} reducerName="ReportReducer" objectName="storageValueReport"
                        fixedHeight style={{ whiteSpace: "nowrap" }} className="mt-0" />
                </Card.Body>
            </Card>
        </div>
    )
}
export default StorageValueReport;